export const budgetsApiPaths = <const>{
    qBooksBudgets: 'companies/:companyId/qbooks/budgets',
    qBooksBudgetsSync: 'companies/:companyId/qbooks/budgets/sync',
    qBooksBudget: 'companies/:companyId/qbooks/budgets/:budgetId',
    qBooksBudgetSync: 'companies/:companyId/qbooks/budgets/:budgetId/sync',
    qBooksBudgetsImpact: 'companies/:companyId/qbooks/requests/:requestId/budgets',
};
